import type { PaymentStatus } from '@/lib/api/sales-order-api'
import { Badge } from '@/components/ui/badge'
import { m } from '@/lib/paraglide/messages'

export const PAYMENT_LABELS: Record<PaymentStatus, () => string> = {
    unpaid: m.order_payment_unpaid,
    partial: m.order_payment_partial,
    paid: m.order_payment_paid,
}

// Nhãn ngắn cho bảng danh sách (giữ cell gọn như trước).
const PAYMENT_LABELS_SHORT: Record<PaymentStatus, () => string> = {
    unpaid: m.order_payment_short_unpaid,
    partial: m.order_payment_short_partial,
    paid: m.order_payment_short_paid,
}

// Nền nhạt + chữ đậm cùng tông (tương phản AA↑), có bản dark. Chưa TT = đỏ (cần
// chú ý còn nợ), 1 phần = hổ phách (dở dang), đã TT = xanh lá (xong).
export const PAYMENT_COLORS: Record<PaymentStatus, string> = {
    unpaid: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
    partial:
        'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
    paid: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200',
}

export function PaymentStatusBadge({
    status,
    short = false,
}: {
    status: PaymentStatus
    /** true → nhãn ngắn (dùng trong bảng danh sách). Mặc định nhãn đầy đủ. */
    short?: boolean
}) {
    const labels = short ? PAYMENT_LABELS_SHORT : PAYMENT_LABELS
    // Đơn có payment_status rỗng thì tra bảng nhãn lẫn bảng màu đều trượt: badge
    // mất chữ, mất luôn class màu nên rơi về `bg-primary` — ra một viên pill xanh
    // trống cạnh mã đơn. Không có gì để nói thì không vẽ gì.
    if (!status?.trim()) return null

    return (
        <Badge className={PAYMENT_COLORS[status]}>
            {labels[status]?.() ?? status}
        </Badge>
    )
}
